const Helper = {
    getOriginalFilename: function(url) {
        if(typeof url === 'string') {
            const splittedUrl = url.split('/');
            return splittedUrl[splittedUrl.length - 1].substring(37);
        }
    }
}

export default Helper;

export function debounce (fn, delay) {
    let timeoutID = null;
    return function () {
        clearTimeout(timeoutID)
        const args = arguments;
        const that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args)
        }, delay)
    }
}
